import React, { useState } from 'react';
import { history, useIntl } from 'umi';
import CardSlot from '@/pages/intelligence/components/CardSlot';
import Abnormal from '@/pages/intelligence/components/Abnormal';
import ExpandCollapseText from '@/pages/intelligence/components/ExpandCollapse';
import { getCompanyDetailsPath } from '@/pages/intelligence/utils/topchartsUtils';
import './index.scss';

const Activities = (porps: any) => {
  const { loading, data, companyId } = porps;

  const { formatMessage } = useIntl();

  return (
    <CardSlot
      className="dbi-activities"
      title={formatMessage({ id: 'dbi_company_activities' })}
      isAction={true}
      iconList={[]}
      getDetails={() => {
        if (!companyId) return;
        const searchParams = new URLSearchParams();
        searchParams.set('anchor', 'investments');
        let url = getCompanyDetailsPath({ companyId, tab: 'Financials' });
        url = `${url}?${searchParams.toString()}`;
        history?.push(url);
      }}
    >
      <Abnormal
        isLoading={loading}
        isError={false}
        isNoData={!data || (Array.isArray(data) && !data?.length)}
        component={
          <>{Array.isArray(data) && !!data?.length && data.map((e: any, i: any) => <Context key={i} e={e} />)}</>
        }
      />
    </CardSlot>
  );
};

export default Activities;

const Context = (porps: any) => {
  const { e } = porps;
  const [isShow, setShow] = useState(false);

  return (
    <div className="dbi-activities-item">
      <div className="dbi-activities-title">
        <div className="text-title">{e.title}</div>
        <div className="text-desc">{e.time}</div>
      </div>
      <ExpandCollapseText
        rowNum={3}
        className="dbi-activities-text"
        text={e.text}
        isShow={isShow}
        onClick={() => {
          setShow(!isShow);
        }}
      />
    </div>
  );
};
